import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import Iconify from '../../components/common/Iconify';
import { PATH_DASHBOARD } from '../../router/paths';

const MenuNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);

  // Map routes to indexes for easier navigation state management
  const routes = [PATH_DASHBOARD.home, PATH_DASHBOARD.cart, PATH_DASHBOARD.me];

  // Sync navigation state with the current location
  useEffect(() => {
    const currentIndex = routes.findIndex((path) => {
      return location.pathname === path;
    });
    setValue(currentIndex !== -1 ? currentIndex : 0);
  }, [location.pathname, routes]);

  const handleNavigation = (newValue) => {
    setValue(newValue);
    navigate(routes[newValue]);
  };

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => handleNavigation(newValue)}
      style={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        height: '61px',
        zIndex: 10,
        left: 0,
      }}
    >
      <BottomNavigationAction label="Home" icon={<Iconify icon={'duo-icons:dashboard'} />} />
      <BottomNavigationAction
        label="Cart"
        icon={
          <Iconify
            icon={'solar:cart-large-bold-duotone'}
            sx={{
              width: '28px',
              height: '28px',
            }}
          />
        }
      />
      <BottomNavigationAction label="Me" icon={<Iconify icon={'duo-icons:user'} />} />
    </BottomNavigation>
  );
};

export default MenuNavigation;
